import { Button, Modal, Spin } from "antd";
import styled from "styled-components";

import { useGlobalContext } from "../../context/GlobalContext";

import useGet from "../common/useGet";
import { useEffect } from "react";
import { formatDateTime } from "../../utils/helpers";

export const DisbursementHealthCheck = () => {
  const { data: globalData, updateData } = useGlobalContext();
  const { openDisbursementHealthCheck } = globalData || {};

  const {
    loadData: checkDisbursementHealthCheck,
    loading: checkingDisbursementHealthCheck,
    data: DisbursementHealthCheckData,
  } = useGet();

  const handleClose = () => {
    updateData({ openDisbursementHealthCheck: false });
  };

  // Check for Disbursement Health when modal opens
  useEffect(() => {
    if (openDisbursementHealthCheck) {
      checkDisbursementHealthCheck({ api: "disbursement/health-check/" });
    }
  }, [openDisbursementHealthCheck]);

  // Render a list of probe cards. Each item is expected to have
  // probeName, result, and message (matching the API shape).
  const renderProbeCards = (items: any[]) =>
    items.map((item: any, index: number) => (
      <div key={index}>
        <DisbursementHealthCheckDataContainer>
          <strong style={{ fontSize: "1rem" }}>{item.probeName}</strong>
          <br />
          <span
            style={{
              color: item.result === "OK" ? "#16a34a" : "#FF0000",
              fontWeight: "bold",
            }}
          >
            {item.result}
          </span>{" "}
          – {item.message}
        </DisbursementHealthCheckDataContainer>
      </div>
    ));

  return (
    <Modal
      open={!!openDisbursementHealthCheck}
      onCancel={handleClose}
      title={
        DisbursementHealthCheckData
          ? "Disbursement Service Health Overview"
          : "No Disbursement Health Check Data"
      }
      footer={null}
      centered
      width={500}
    >
      {checkingDisbursementHealthCheck || !DisbursementHealthCheckData ? (
        <div style={{ textAlign: "center", padding: "40px 0" }}>
          <Spin size="large" />
          <p style={{ marginTop: 16, color: "#8c8c8c" }}>
            Checking Disbursement Health...
          </p>
        </div>
      ) : (
        <DisbursementHealthCheckModalContent>
          <h3
            style={{ color: "#1a75ba", fontWeight: "bold", fontSize: "1.5rem" }}
          >
            Disbursement Health Check
          </h3>

          <p
            style={{
              textAlign: "center",
              fontSize: "1.1rem",
              color: "#64748b",
            }}
          >
            <strong>Overall Status:</strong>
            <span style={{ color: "#16a34a", fontWeight: "bold" }}>
              {" "}
              {DisbursementHealthCheckData?.status}
            </span>{" "}
            ✅
          </p>
          <p
            style={{
              textAlign: "center",
              color: "#475569",
              marginBottom: "0.25rem",
            }}
          >
            {DisbursementHealthCheckData?.message}
          </p>
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "0.85rem",
              marginBottom: "0.5rem",
            }}
          >
            Checked at: {formatDateTime(DisbursementHealthCheckData?.timestamp)}
          </p>
          <p
            style={{
              textAlign: "center",
              color: "#475569",
              marginBottom: "2rem",
            }}
          >
            <strong>System Health:</strong>
            <span
              style={{
                color:
                  DisbursementHealthCheckData?.result?.isSystemHealth === "OK"
                    ? "#16a34a"
                    : "#FF0000",
                fontWeight: "bold",
                marginLeft: 6,
              }}
            >
              {DisbursementHealthCheckData?.result?.isSystemHealth}
            </span>{" "}
            – {DisbursementHealthCheckData?.result?.message}
          </p>

          <DisbursementHealthCheckDataContent>
            {DisbursementHealthCheckData?.results?.length ? (
              renderProbeCards(DisbursementHealthCheckData.results)
            ) : (
              <p>No Disbursement Health Check Data</p>
            )}
          </DisbursementHealthCheckDataContent>

          {Array.isArray(DisbursementHealthCheckData?.result?.results) && (
            <>
              <h4
                style={{
                  width: "100%",
                  textAlign: "left",
                  color: "#1a75ba",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  margin: "1rem 0 0.5rem 0",
                }}
              >
                Result Details (
                {DisbursementHealthCheckData.result.results.length})
              </h4>

              <DisbursementHealthCheckDataContent>
                {renderProbeCards(DisbursementHealthCheckData.result.results)}
              </DisbursementHealthCheckDataContent>
            </>
          )}

          <div
            style={{
              display: "flex",
              gap: 12,
              justifyContent: "center",
              marginTop: 24,
            }}
          >
            <Button onClick={handleClose} size="large">
              Close
            </Button>
          </div>
        </DisbursementHealthCheckModalContent>
      )}
    </Modal>
  );
};

// Styled Components for Disbursement Health Check Modal
const DisbursementHealthCheckModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  text-align: center;

  h3 {
    margin-bottom: 20px;
    color: #262626;
    font-size: 18px;
  }

  p {
    color: #595959;
  }
`;

const DisbursementHealthCheckDataContent = styled.p`
  display: grid;
  gap: 1rem;
`;
const DisbursementHealthCheckDataContainer = styled.div`
  background: white;
  padding: 1.2rem;
  border-radius: 12px;
  border-left: 5px solid #16a34a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;
